export enum DealType {
    UNKNOWN = 0,
    SELL = 1,
    RENT = 2,
}
